<template>
	<transition :name="name" :appear="appear" :mode="mode">
		<slot />
	</transition>
</template>

<script>
export default {
	name: 'TTransition',
	props: {
		name: {
			type: String,
			default: 'fade',
			validator: function(value) {
				return ['fade', 'slide-fade'].indexOf(value) !== -1;
			}
		},
		appear: {
			type: Boolean,
			default: true,
		},
		mode: {
			type: String,
			default: 'out-in'
		}
	}
};
</script>

<style lang="scss" scoped>
.slide-fade {
	&-move {
		transition: opacity .25s linear, transform .25s ease-in-out;
		transition-delay: .5s;
	}
	&-leave-active {
		transition: opacity .15s linear, transform .15s cubic-bezier(.5,0,.7,.4); //cubic-bezier(.7,0,.7,1);
	}
	
	&-enter-active {
		transition: opacity .25s linear, transform .25s cubic-bezier(.2,.5,.1,1);
	}
	&-enter, &-leave-to {
		opacity: 0;
	}
	
	&-enter { transform: translateX(-.5em); }
	&-leave-to { transform: translateX(.5em); }
}

.fade {
	&-enter-active, &-leave-active {
		transition: opacity 0.3s;
	}
	&-enter, &-leave-to {
		opacity: 0;
	}
}
</style>

<docs>
```jsx

new Vue({
	data(){
		return {
			show: true,
		}
	},
	methods: {
		onChange(value) {
			this.show = value;
		}
	},
	template: `
	<div style="width:500px; height:150px;">
		<div style="padding: 10px 0px;">
			<t-switch label="Toggle" :checked="show" @change="onChange($event)"></t-switch>
		</div>
		
		<div style="height: 50px; margin: 10px 0;">
			<div style="font-family: arial; color: #666;">Fade</div>
			<t-transition style="min-height: 40px">
				<t-contact-info v-show="show" name="Jørn Jenssen" phone="99337712" company="Scan Vest Dekk AS"/>
			</t-transition>
		</div>
		<div style="height: 50px;">
			<div style="font-family: arial; color: #666;">Slide fade</div>
			<t-transition name="slide-fade" style="min-height: 40px">
				<t-contact-info v-show="show" name="Arvid Aronsen" phone="99887766" company="Scan Øst Felg AS"/>
			</t-transition>
		</div>
		
		
	</div>
	`
});
```
</docs>